import { render, staticRenderFns } from "./CeisaClientLoginDetail.vue?vue&type=template&id=9d2fa472&scoped=true&"
import script from "./CeisaClientLoginDetail.vue?vue&type=script&lang=js&"
export * from "./CeisaClientLoginDetail.vue?vue&type=script&lang=js&"
import style0 from "./CeisaClientLoginDetail.vue?vue&type=style&index=0&id=9d2fa472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2fa472",
  null
  
)

export default component.exports